import { render, staticRenderFns } from "./ModuleBox.vue?vue&type=template&id=82a5b6ae&scoped=true&"
import script from "./ModuleBox.vue?vue&type=script&lang=js&"
export * from "./ModuleBox.vue?vue&type=script&lang=js&"
import style0 from "./ModuleBox.vue?vue&type=style&index=0&id=82a5b6ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a5b6ae",
  null
  
)

export default component.exports